<template>
  <div>
    <p class="text-2xl mb-6">
      {{
        editing
          ? `Editer le Monitor d'URL "${monitorTitle}"`
          : "Créer un nouveau Monitor d'URL"
      }}
    </p>
    <url-monitor-form :monitor-id="monitorId"></url-monitor-form>
  </div>
</template>

<script>
import UrlMonitorForm from "@/components/web-perf/synthetic-monitoring/forms/UrlMonitorForm.vue";
import axios from "@axios";

export default {
  name: "SyntheticMonitoringAddEdit",
  components: {
    UrlMonitorForm,
  },
  data() {
    return {
      monitorTitle: "",
    };
  },
  computed: {
    editing() {
      return !!this.$route.params.id;
    },
    monitorId() {
      return this.$route.params.id || null;
    },
  },
  async mounted() {
    if (this.editing) {
      // Load monitor title for display
      try {
        const response = await axios.get(`/url-monitors/${this.monitorId}`);
        this.monitorTitle = response.data.title;
      } catch (error) {
        console.error("Error loading monitor title:", error);
      }
    }
  },
};
</script>
